<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="unit.pkId ? '编辑' : '新建'"
    width="600px"
    @close="$reset('form')"
  >
    <el-form ref="form" :model="unit" :rules="ruleValidate" class="form" label-width="50px">
      <el-form-item label="编号" prop="unitNo">
        <el-input v-model="unit.unitNo" placeholder="请输入计量单位编号" />
      </el-form-item>
      <el-form-item label="名称" prop="unitName">
        <el-input v-model="unit.unitName" placeholder="请输入计量单位名称" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      unit: {
        pkId: 0,
        unitNo: "",
        unitName: "",
      },
      ruleValidate: {
        unitNo: { required: true, message: "请输入计量单位编号", trigger: "blur" },
        unitName: { required: true, message: "请输入计量单位名称", trigger: "blur" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.unit = Object.assign(this.unit, row);
      }
    },

    // 确定
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "units", this.unit)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                if (this.unit.pkId) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
